import { SVGIcon } from '@superops/super-icons';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { EventEmitter, NewTask, toast } from '@nile/components';
import { constructTaskObject } from '@nile/projects/src/Utils';
import { TicketClient, UPDATE_TASK } from '@nile/graphql';
import { Button, Link, TextStyle } from '@superops/ui-design-system';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Tooltip } from 'react-clone-tippy';

const WorklogTask = ({
  task,
  workItem,
  hideTaskWorkItem,
  viewOnly,
  iconSize,
  classNames,
  gap,
  hideIcon,
  onEditCompleted
}) => {
  const flags = useFlags();
  const taskTimerFlag = flags?.taskTimer;
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = () => setSheetActive(!sheetActive);

  const workItemModule = workItem?.module || 'TICKET';

  const updateTask = (type, updatedTask) => {
    const taskObj = constructTaskObject(updatedTask);
    const taskId = updatedTask?.taskId;
    let module;
    if (updatedTask?.workItem?.module) {
      module = updatedTask.workItem.module;
    } else if (updatedTask?.ticket) {
      module = 'TICKET';
    } else {
      module = 'PROJECT';
    }

    TicketClient.mutate({
      mutation: UPDATE_TASK,
      variables: {
        taskId: taskId,
        module: module,
        input: taskObj
      }
    }).then((res) => {
      if (res?.data?.updateTask) {
        toast('success', 'Task updated successfully');
        // Close task modal
        EventEmitter.dispatch('toggleGlobalTask', null);
        if (onEditCompleted) {
          onEditCompleted();
        }
      }
    });
  };

  const details =
    workItemModule === 'TICKET'
      ? {
          operation: 'UPDATE',
          ticketId: workItem?.workId,
          taskId: task?.taskId
        }
      : {
          operation: 'UPDATE',
          projectId: workItem?.workId,
          taskId: task?.taskId
        };

  const openTaskModal = () => {
    setSheetActive(true);
    const taskData = {
      name: task?.title,
      hideIcon: true,
      data: task,
      module: workItemModule === 'TICKET' ? 'TICKET_TASK' : 'PROJECT_TASK',
      details: details,
      locked: true,
      showParent: !hideTaskWorkItem,
      workItem: workItem,
      addOrUpdateTechGroup: updateTask,
      hideDelete: true
    };
    EventEmitter.dispatch('toggleGlobalTask', taskData);
  };

  return (
    <>
      {!isEmpty(task) && taskTimerFlag ? (
        <>
          {viewOnly ? (
            <div
              className={`flex actr ${gap || 'g10'} full-width ellipsis w100`}
            >
              <div className="flex ignoreOverride">
                <SVGIcon name="Tasks" size={iconSize || 'sm'} />
              </div>
              <div
                className={classNames ? `flex ${classNames}` : 'flex f-size-12'}
              >
                <TextStyle>
                  <div className="ellipsis">{task?.title}</div>
                </TextStyle>
              </div>
            </div>
          ) : (
            <Link onClick={openTaskModal} ellipsis fontWeight="normal">
              <div className="flex g8 actr">
                {!hideIcon && (
                  <div className="flex">
                    <div className="flex ignoreOverride">
                      <SVGIcon name="Tasks" color="#091EF5" />
                    </div>
                  </div>
                )}

                <Tooltip
                  title={task?.title}
                  delay={200}
                  duration={250}
                  position="bottom"
                  inertia
                  trigger="mouseenter"
                  animation="shift"
                  animateFill={false}
                  className="ellipsis"
                >
                  <div className="ellipsis">{task?.title}</div>
                </Tooltip>
              </div>
            </Link>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default WorklogTask;
